import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Supabase接続テスト関数をインポート（開発時のみ）
if (import.meta.env.DEV) {
  import('./utils/supabaseConnectionTest');
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
